/**
 * Salesforce-style date literals (aligned with list filters and backend dateLiteralResolver).
 */
export const DATE_LITERAL_PATTERN =
  /^(TODAY|YESTERDAY|TOMORROW|THIS_WEEK|LAST_WEEK|NEXT_WEEK|THIS_MONTH|LAST_MONTH|NEXT_MONTH|THIS_QUARTER|LAST_QUARTER|NEXT_QUARTER|THIS_YEAR|LAST_YEAR|NEXT_YEAR|LAST_N_DAYS:\d+|NEXT_N_DAYS:\d+|LAST_N_WEEKS:\d+|NEXT_N_WEEKS:\d+|LAST_N_MONTHS:\d+|NEXT_N_MONTHS:\d+|LAST_N_YEARS:\d+|NEXT_N_YEARS:\d+)$/i;

const ISO_DATE_PATTERN = /^\d{4}-\d{2}-\d{2}$/;

export function isDateLiteral(value) {
  return typeof value === 'string' && DATE_LITERAL_PATTERN.test(value.trim());
}

export function isIsoDateString(value) {
  if (typeof value !== 'string') return false;
  const s = value.trim();
  if (!ISO_DATE_PATTERN.test(s)) return false;
  const d = new Date(`${s}T00:00:00`);
  return !Number.isNaN(d.getTime());
}

/** True for TODAY, LAST_N_DAYS:7, or fixed YYYY-MM-DD (filter/report static literal mode). */
export function isValidDateFilterLiteralValue(value) {
  if (value == null || String(value).trim() === '') return false;
  const s = String(value).trim();
  return isDateLiteral(s) || isIsoDateString(s);
}

export function validateDateFilterLiteralValue(value) {
  const s = String(value ?? '').trim();
  if (!s) {
    return { valid: false, message: 'Value is required' };
  }
  if (isValidDateFilterLiteralValue(s)) {
    return { valid: true, message: '' };
  }
  return {
    valid: false,
    message: 'Use TODAY, LAST_N_DAYS:7, or YYYY-MM-DD (see date literals help)',
  };
}

export function validateDateFilterBetweenLiteralValue(value) {
  const s = String(value ?? '').trim();
  if (!s) {
    return { valid: false, message: 'Enter both From and To values' };
  }
  const parts = s.split('|').map((p) => p.trim());
  const from = parts[0] || '';
  const to = parts[1] || '';
  if (!from || !to) {
    return { valid: false, message: 'Enter both From and To values' };
  }
  if (!isValidDateFilterLiteralValue(from) || !isValidDateFilterLiteralValue(to)) {
    return {
      valid: false,
      message: 'Each side must be TODAY, a date literal, or YYYY-MM-DD',
    };
  }
  return { valid: true, message: '' };
}

export function isDateOrDateTimeFieldType(dataType) {
  const dt = String(dataType || '').toLowerCase();
  return (
    dt === 'date' ||
    dt === 'datetime' ||
    dt === 'datetime2' ||
    dt === 'timestamp' ||
    dt === 'timestamptz'
  );
}
